window.showArtworkError = function (message) {
  return new Promise((resolve) => {
    document.querySelector(".artwork-error-popup")?.remove();

    const popup = document.createElement("div");
    popup.className = "artwork-error-popup";

    popup.innerHTML = `
      <div style="position:fixed;inset:0;z-index:999999;display:flex;
        align-items:center;justify-content:center;background:rgba(15,23,42,.55);
        padding:20px">

        <div style="width:100%;max-width:380px;padding:24px;background:#fff;
          border-radius:12px;box-shadow:0 20px 50px rgba(15,23,42,.25);
          text-align:center">

          <h3 style="margin:0 0 8px;color:#101828;font-size:20px">
            Invalid artwork
          </h3>

          <p class="artwork-error-message"
            style="margin:0 0 20px;color:#475467;font-size:14px;line-height:1.5">
          </p>

          <button type="button"
            style="padding:10px 24px;border:0;border-radius:7px;
            background:#ee7b29;color:#fff;font-weight:600;cursor:pointer">
            OK
          </button>
        </div>
      </div>
    `;

    popup.querySelector(".artwork-error-message").textContent = message;

    popup.querySelector("button").addEventListener("click", () => {
      popup.remove();
      resolve();
    });

    document.body.appendChild(popup);
    popup.querySelector("button").focus();
  });
};